import { Toast } from 'antd-mobile';
import http from 'axios';

declare module 'axios' {
  interface AxiosRequestConfig {
    skipTransformResponse?: boolean;
    original?: boolean;
  }
}

const baseURL = process.env.NEXT_PUBLIC_COMMON_API_HOST;

const ecommerce = http.create({
  baseURL,
  timeout: 20e3,
});

ecommerce.interceptors.response.use(
  (response) => {
    const { config, data } = response;
    if (config.original) {
      return response;
    }
    if (config.skipTransformResponse) {
      return data;
    }

    return data.data;
  },
  (error) => {
    Toast.show({
      icon: 'fail',
      content: error.response?.data?.message || error.message,
      duration: 3,
    });
    throw error;
  },
);

export default ecommerce;
